import type { DirectChannel, Message } from '@/types/api';

/**
 * The message to preview for a DM row: the newest of the live store's head
 * (the store keeps each channel newest-first) and the channel's snapshot.
 */
export function latestMessage(ch: DirectChannel, liveNewest: Message | undefined): Message | null {
  const snap = Array.isArray(ch.messages) && ch.messages.length ? ch.messages[0]! : null;
  if (!liveNewest) return snap;
  if (!snap) return liveNewest;
  return Date.parse(snap.createdAt) > Date.parse(liveNewest.createdAt) ? snap : liveNewest;
}
